export default function(record, commit) {
	if (record.id === 'profile')
		commit('provider/updateProvider')
	else if (record.provider.endsWith(':schedule'))
		commit('provider/addSchedule')
	else if (record.provider.endsWith(':message'))
		commit('provider/addMessage')
}
